export default __webpack_public_path__ + "static/media/kcs-logo.e723d0a2.png";